// extracted by mini-css-extract-plugin
export default {"sidebardata":"Layout_sidebardata__mZxLL"};